
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"red","d":"M28.01 37.99L38.42 32l-10.41-6v11.99z"}}),_c('path',{attrs:{"d":"M32 0a32 32 0 1032 32A32 32 0 0032 0zm19.16 41.65a5 5 0 01-3.52 3.53A122.2 122.2 0 0132 46a116.92 116.92 0 01-15.65-.85 5 5 0 01-3.51-3.54A53.42 53.42 0 0112 32a53.42 53.42 0 01.84-9.62 5.11 5.11 0 013.52-3.56A122.2 122.2 0 0132 18a116.92 116.92 0 0115.65.86 5 5 0 013.52 3.53A50.39 50.39 0 0152 32a53.42 53.42 0 01-.84 9.65z","fill":"red"}})])
          )
        }
      }
    